export default __webpack_public_path__ + "static/media/resume.6bd2c12a.pdf";